import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';

import { FormWithErrorsRegister } from '@/hooks/useFormWithErrors';
import { useTranslator } from '@/hooks/useTranslator';
import type { paymentMethodFiatSchema } from '@/schemas/paymentMethod';

type PaymentMethodForm = typeof paymentMethodFiatSchema.infer;

interface Props {
  readonly register: FormWithErrorsRegister<PaymentMethodForm>;
  readonly setValue: UseFormSetValue<PaymentMethodForm>;
  readonly watch: UseFormWatch<PaymentMethodForm>;
}

export const CVUAccountDetailsFields: React.FC<Props> = ({
  register,
  setValue,
  watch,
}: Props): React.ReactElement => {
  const tr = useTranslator();

  const [firstName, lastName, recipientType] = watch(['firstName', 'lastName', 'recipientType']);

  React.useEffect((): void => {
    if (recipientType === 'company' && firstName) {
      // For company contacts, use the company name (stored in firstName)
      setValue('recipientName', firstName);
    } else if (recipientType === 'individual' && firstName) {
      // For individual contacts, use firstName + lastName
      const fullName = lastName ? `${firstName} ${lastName}` : firstName;
      setValue('recipientName', fullName);
    }
  }, [firstName, lastName, recipientType, setValue]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="body2" color="text.primary">
        {tr('BANK_ACCOUNT_INFORMATION')}
      </Typography>
      <TextField {...register({ name: 'cvu', label: tr('CVU_OR_CBU') })} />
    </Box>
  );
};
